const ProcessSection = () => {
  const steps = [
    {
      num: "01",
      title: "Learn",
      desc: "We study your best clients, your voice, and who you're trying to reach. No templates."
    },
    {
      num: "02",
      title: "Build", 
      desc: "Campaigns crafted to sound like you. Messaging you'd actually send yourself."
    },
    {
      num: "03",
      title: "Launch",
      desc: "Targeted outreach, tested and refined. We learn what works and do more of it."
    },
    {
      num: "04",
      title: "Connect",
      desc: "Interested prospects get handed off warm. You take it from there."
    }
  ];

  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
          How It Works
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight mb-12 md:mb-16">
          Simple. Deliberate. Effective.
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {steps.map((step) => (
            <div key={step.num}>
              <div className="flex items-center gap-3 mb-4 md:mb-5">
                <span className="text-[#6DBE2E] text-xs font-mono">{step.num}</span>
                <div className="h-px bg-[#6DBE2E]/30 flex-1" />
              </div>
              <h3 className="text-white text-lg md:text-xl font-medium mb-3">{step.title}</h3>
              <p className="text-white/50 text-sm md:text-[15px] leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
